/*Package importing*/
import React, { Component } from 'react';

class Banner extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    }
  }

  componentDidMount() {
    // alert('image');
  }

  render() {


    return (
        <div className="container px-0 e-banner-preview">
        {
            this.props.banner.banner_type==1?
            <div className="row">
                <div className="col-lg-12 py-2">
                    <img src={this.props.banner.data[0].content} alt="banner" />
                </div>
            </div>
            : this.props.banner.banner_type==2?
            <div className="row">
                {
                    this.props.banner.data.map(item=>(
                        <div className="col-lg-6 py-2">
                            <img src={item.content} alt="banner" />
                        </div>
                    ))
                }
            </div>
             : this.props.banner.banner_type==3?
             <div className="row">
                 {
                     this.props.banner.data.map(item=>(
                         <div className="col-lg-4 py-2">
                             <img src={item.content} alt="banner" />
                         </div>
                     ))
                 }
             </div>
             : this.props.banner.banner_type==4?
             <div className="row">
                 {
                     this.props.banner.data.map(item=>(
                         <div className="col-lg-3 py-2">
                             <img src={item.content} alt="banner" />
                         </div>
                     ))
                 }
             </div>
             : this.props.banner.banner_type==5?
             <div className="row">
                 <div className="col-lg-6 py-2">
                    <img src={this.props.banner.data[0].content} alt="banner" />
                 </div>
                 <div className="col-lg-6">
                 {
                     this.props.banner.data.map((item, i)=>(
                         <>
                         {
                             i!=0?
                             <div className="row px-3 py-2">
                                <img src={item.content} alt="banner" />
                            </div>
                            :
                            null
                         }
                         </>
                     ))
                 }
                 </div>
             </div>
             : this.props.banner.banner_type==6?
             <div className="row">
                 <div className="col-lg-4">
                 {
                     this.props.banner.data.map((item, i)=>(
                         <>
                         {
                             i<2?
                             <div className="row py-2 px-3">
                                <img src={item.content} alt="banner" />
                            </div>
                            :
                            null
                         }
                         </>
                     ))
                 }
                 </div>
                 <div className="col-lg-4 py-2">
                    <img src={this.props.banner.data[2].content} alt="banner" />
                 </div>
                 <div className="col-lg-4">
                 {
                     this.props.banner.data.map((item, i)=>(
                         <>
                         {
                             i>2?
                             <div className="row py-2 px-3">
                                <img src={item.content} alt="banner" />
                            </div>
                            :
                            null
                         }
                         </>
                     ))
                 }
                 </div>
             </div>

             :this.props.banner.banner_type==7?
             <div className="row">
                 <div className="col-lg-12 py-2">
                     <img src={this.props.banner.data[0].content} alt="banner" />
                 </div>
             </div>
             : this.props.banner.banner_type==8?
             <div className="row">
                 {
                     this.props.banner.data.map(item=>(
                         <div className="col-lg-3 py-2">
                             <img src={item.content} alt="banner" />
                         </div>
                     ))
                 }
             </div>
             : this.props.banner.banner_type==9?
             <div className="row">
                 {
                     this.props.banner.data.map(item=>(
                         <div className="col-lg-6 py-2">
                             <img src={item.content} alt="banner" />
                         </div>
                     ))
                 }
             </div>
             :
             null
        }
        </div>
    );
  }
}

export default Banner;
